import React from 'react';
import PropTypes from 'prop-types';
import { enabledByProvider, modelWarnings } from './aiModels';

// One row per AI task: which enabled model it runs on. Changing the
// dropdown assigns at once. Native select: PrimeReact 6 has no optgroups.
export default function AiTaskTable({ tasks, models, busy, onAssign }) {
    const groups = enabledByProvider(models);
    const byId = Object.fromEntries(models.map(m => [m.id, m]));

    return (
        <table className="st-table st-task-table">
            <thead>
                <tr>
                    <th>Task</th>
                    <th>Model</th>
                    <th />
                </tr>
            </thead>
            <tbody>
                {tasks.map(row => {
                    const assigned = byId[row.ai_model_id];
                    const warnings = assigned ? modelWarnings(assigned) : ['No model assigned'];
                    return (
                        <tr key={row.task}>
                            <td className="st-task-label">
                                {row.label}
                                {row.description && (
                                    <span className="st-tip" tabIndex={0} data-tip={row.description} aria-label={row.description}>
                                        <i className="pi pi-info-circle" />
                                    </span>
                                )}
                            </td>
                            <td>
                                <select
                                    className="st-select"
                                    aria-label={`Model for ${row.label}`}
                                    value={row.ai_model_id || ''}
                                    disabled={busy === `task-${row.task}`}
                                    onChange={e => onAssign(row.task, Number(e.target.value))}
                                >
                                    {!assigned && <option value="">Choose a model</option>}
                                    {assigned && !assigned.enabled && (
                                        <option value={assigned.id}>{assigned.label} (disabled)</option>
                                    )}
                                    {groups.map(group => (
                                        <optgroup key={group.provider} label={group.label}>
                                            {group.models.map(m => (
                                                <option key={m.id} value={m.id}>{m.label}</option>
                                            ))}
                                        </optgroup>
                                    ))}
                                </select>
                            </td>
                            <td className="st-warnings">
                                {warnings.map(w => (
                                    <span key={w} className="st-warning"><i className="pi pi-exclamation-triangle" /> {w}</span>
                                ))}
                            </td>
                        </tr>
                    );
                })}
            </tbody>
        </table>
    );
}

AiTaskTable.propTypes = {
    tasks: PropTypes.arrayOf(PropTypes.shape({
        task: PropTypes.string.isRequired,
        label: PropTypes.string.isRequired,
        description: PropTypes.string,
        ai_model_id: PropTypes.number,
    })).isRequired,
    models: PropTypes.array.isRequired,
    busy: PropTypes.string,
    onAssign: PropTypes.func.isRequired,
};
